import AboutHero from "../components/about/AboutHero";
import SectionTextbox from "../components/standalone/SectionTextbox";

export default function AboutSection() {
  const paragraphs = [
    {
      'subtitle': '',
      'text': [
        'SO ENGLISH!のウェブサイトにお越しいただきありがとうございます。私は、2021年にベルギーに留学するまで、3校の専門学校勤務とSO ENGLISH!の授業を掛け持ちしていましたが、渡航をきっかけに完全ノマドになり、2023年現在は場所を選ばず、日本と海外を行き来しながらフリーランスの講師業をしています。行った国は20を超えます。国の様子はインスタグラムにまとめてあるので良かったら見てみてくださいね。趣味は国内外問わず美術館を周ることで、旅先で街や自然の風景の絵を描くことです。そして旅行先での一期一会の交流が何より好きです。昔からこのような生き方をしようと思っていたわけではありませんが、日々の経験と共に変わっていく自分自身の感覚を大切にしながら生きていたら、気が付いたらこのような場所にいたというわけです。',
        'ここでは、簡単に私の生い立ちと、どのようにして私が今の仕事をし、現在の人生観を持ったのかをお伝えしておきます。'
      ],
    },
    {
      'subtitle': '病弱だった幼少期が、現在の「一秒も無駄にする時間はない」という生き方の原点です。',
      'text': [
        '1989(平成元)年2月20日、東京都下で日本人の両親の元に生まれました。難産の末の2000グラム台の未熟児で、生まれた時は呼吸をしていなかった為泣き声を上げなかったようです。その3年後妹が生まれ、病弱だった私に対比してとても元気に育ちました。そのまた2年後に突発的な病気で1カ月間の入院。その後も小児喘息で病院通いの幼少期を過ごしました。助産師、医師の方々に二度命を救ってもらった事実を、今でもふと思い出しては、元気に生きられていることの有難さを深く噛みしめています。'
      ],
      'imgURL': [
        'https://res.cloudinary.com/dc1aiqs4p/image/upload/c_thumb,w_500/v1688596431/Aboutsectionchildhoodphotoedit_cenav0.webp'
      ],
    },
    {
      'subtitle': '一味も二味も違った、本間家の教育。',
      'text': [
        '両親が言っていた言葉で一番心に残っているのは「人と違うことはかっこいい」というものかもしれません。例え他多数が自分と違う意見でも、思っていることをちゃんと言うのがいいと信じて育ちました。今も昔も、一番好きなアニメはセーラームーンで、小さい頃から好きなものを好きと言って、それを尊重してくれる環境があったのは、とても有難いことだったと今になって思います。保育園にセーラームーンの靴を履いて行った時に、他のお母さんたちが私の母に「そうちゃん男の子なのになんでセーラムーンの靴なんて履かせてるの？」と言った時母は「好きだからです」ときっぱり言い放ったそうです。笑',
        'それから、本間家では「子ども扱い」という言葉はなかったように思います。逆に言うと「子供だから仕方ない」という免罪符もありませんでした。自然派の食卓だったので、大人と一緒にスパイスから作った辛口のカレーを食べていましたし、お菓子は煎餅しか食べませんでしたので、あの頃は子供の味覚に合うお菓子がたくさん出る友達の家がとても羨ましかったです。家では家族会議や意見交換ノートがあり、そこで必ず「そうちゃんはどう思うの？」と聞かれていました。ちゃんと話せないと自分の意見は受け入れてもらえない為、論理だてて説明することを徹底せざるを得なかったのです。',
        '習い事も、塾も、自習も、受験も、すべて自分次第。親から言われてすることは一つもなく、すべて自分で決めなければならないという環境下で、自分で調べ、理由を持って決断をしました。なんでもやりたがった妹に対して、私は子供ながらに何か明確な理由が無いと続かないと思っていたので、習い事はほとんどしませんでした。唯一通った習い事は、小学校6年生の時に自分で「行きたい」と言った子供英会話スクールでした。'
      ]
    },
    {
      'subtitle': '発音から始まった、英語の旅。',
      'text': [
        '英会話スクールで最初に学んだのはフォニックスです。今でこそ周知の英語のスペルと音の関係を学ぶものですが、あの頃にカリキュラムに取り入れていたスクールは少なかったと思います。私は日本語に無いRの音がとても好きでした。Rabbit、Run、Really?と、Rが付く単語を知っていくことや、スペルと音のルールを覚えたことで、誰の助けも無く、いわば自転車の補助輪なしで、今まで読めなかったものが読めるようになったのも嬉しかった。横田基地のネイティブの先生と、発音ネイティブの日本人の先生の会話もとってもかっこよかったですし、それを真似て自分の口から英語っぽい音が出てくるのもとても心地よかったのです。'
      ]
    },
    {
      'subtitle': '自分のセクシャリティに悩んだ思春期。',
      'text': [
        '12歳の時、初めて男性に興味があると自覚しました。あの頃は、他の人にばれたらもう生きていられないと思っていたものです。神社に行けば「普通の人に戻れますように!」と本気で神頼みをしていました。'
      ]
    },
    {
      'subtitle': '変わりたい一心で決断した、初めての留学。',
      'text': [
        '留学した理由はたくさんありますが、思い返すと、とにかく変わりたかったように思えます。ゲイである自分が大嫌いなのに、隠した自分がドンドンと内からドアを叩いて、開けようとしてくる、そんな生活が苦しかった。自分のことを知っている人が一人もいない、真新しい環境に行き、一からやり直せば、変われるかもしれないと思い、留学を決意しました。'
      ]
    },
    {
      'subtitle': '初めての国際交流が、とにかく楽しかった。',
      'text': [
        '2005年7月、16歳。高校交換留学。高校に入ってから勉強をさぼってしまったがゆえ、ほとんど英語が話せない状態で、初めてのアメリカ上陸、ノースダコタ州へ!',
        '現地の学校に行く前の1か月の事前研修に、世界各地(日本、フランス、中国、台湾)から留学生17名集められたが、なんと私は、英語のクラス分けで一番下のレベルでした。ほぼ出川イングリッシュで他の国の人とコミュニケーションをとっていました。でも、楽しかった!あれから約20年経った今も、彼らとはたまに連絡を取っています。'
      ],
      'imgURL': [
        'https://res.cloudinary.com/dc1aiqs4p/image/upload/c_thumb,w_500/v1688606075/Studyabroadtwophotoedit_1_trcoei.webp'
      ]
    },
    {
      'subtitle': 'ホストファミリーと現地高校の英語漬けの生活。',
      'text': [
        '9月、ミネソタ州のホストファミリーと住み始めました。1か月の研修だけですぐに英語が話せるようになるほど甘くはないので、とにかく「誤解」の連続!とても優しい家族でしたが、よくケンカはしていました。でもその度に「喧嘩できるぐらい英語が伸びてる!」と少し嬉しかったのです。',
        '半年経った時初めて英語で夢を見ました。ネットも家に無い、LINEもSkypeも無い、国際電話はめちゃくちゃ高いから日本の友達や家族と話す機会はほとんどない。学校でも家でも夢の中でも24時間英語だけの生活のおかげで、みるみる英語が伸びていきました。'
      ]
    },
    {
      'subtitle': '違うことだらけの海外学校生活。',
      'text': [
        '学校生活なしにはやはり留学は語れません。田舎町の3つの地域から子供たちが集まった小さな学校だったので、アジア人は私だけで、良くも悪くも目立っていました。最初は英語が下手だったので、からかわれたり、相手にされないこともあり、悔しくて学校に行きたくないこともありましたが、結果的にとても良い友人に恵まれました。映画でしか見たことがなかったプロムにも行きました。旅行先のホテルで、お風呂の湯気で部屋を満たして「サウナしようぜ」と言ったバカな友人もいました。みんなでパンツ一丁になって、腹を抱えて笑いました。',
        '一番好きな授業はChoir(合唱)で、ニューヨークに修学旅行で行った際、Statue of Liberty(自由の女神)の前でみんなで左胸に手を当て、アメリカ国歌を歌ったことは今も鮮明に覚えています。',
        'アメリカの高校は、日本の学校とは違うことだらけで、本当に毎日がカルチャーショックでした。一番の衝撃は、授業中に寝ている生徒がいないこと。それどころか、円に並べた机に座った生徒たちから出る、質問と意見の嵐。彼らの姿勢に影響を受けて、日本に帰国後、人が変わったように成績優秀者になり、クラスメイトに逆ショックを与えたことは忘れずに記しておきましょう。'
      ],
      'imgURL': [
        'https://res.cloudinary.com/dc1aiqs4p/image/upload/c_thumb,w_750/v1690289233/Aboutsectiontwo750w_ovidpy.webp',
      ],
      'increaseImgSize': true
    },
    {
      'subtitle': 'チャレンジを応援する国、アメリカ。',
      'text': [
        '高校留学での忘れられない思い出の１つは、バンドを組んでいたことです。（ベースの彼が初恋でした。)日本でもバンドを組んでいたので、アメリカでもバンドを組みたい!と意気込み、色んなところで「歌うのが好きだ」と言っていたら、声をかけてくれました。',
        '音楽の先生に直談判して、学校最後の日にコンサートホールを貸し切ってワンマンライブをした時、ホールにたくさんの家族や友人たちが学校内外からも来てくれ、中にはウチワを作ってくれている人たちもいました。',
        '下手くそでも、チャレンジをみんなで応援する国、それがアメリカだと思います。私にとって、もしかすると初めて、居心地が良いと思えた場所だったかもしれません。'
      ],
      'imgURL': [
        'https://res.cloudinary.com/dc1aiqs4p/image/upload/c_thumb,w_750/v1688575331/Aboutsectiontwo2_evq9sb.webp'
      ],
      'increaseImgSize': true
    },
    {
      'subtitle': 'アメリカの、もう一つの家族。',
      'text': [
        '私が使った留学斡旋機関であるASSEのポリシーは、ホストファミリーは必ずボランティアでなければならないというものでした。収入の為の留学生の受け入れではないので、その分受け入れ先を見つけるのがとても大変でした。私のファミリーも、高校が始まる直前に決まり、更に、留学生の受け入れは私が初めてだったのです。(通常はホストファミリーをビジネスでやっている方が多いので、留学生に慣れています。)',
        'お互い探り探りの生活の中、前述の通りすれ違いも多くありましたが、私を完全に家族の一員として受け入れてくれていました。家族旅行にも連れて行ってもらい、親戚一同が集まるクリスマスやThanks Givingなどのイベントも一緒に参加しました。小学生の弟と中学生の妹の学校の発表会にも両親と見に行き、必ず終わった後は「よかったよ」とハグをするのです。大喧嘩の後の仲直りの後もハグ。私が学校で合唱のコンサートやバンドでライブをした時も、家族みんな見に来てくれて、最後にはハグをしました。言語の壁は、ハグが壊してくれたように思います。',
        '一緒に過ごしたのは10カ月だけ。それでも、最後には本当の家族のように感じていました。私がアメリカを去った後、彼らが「また留学生を受け入れるの?」と聞かれた時、「いいえ。他の留学生はSOじゃないもの。」と、飼い犬が死んで次の犬を飼わない人と同じようなことを言ったそうです。笑',
        '日本に帰国する際、Motherから「あなたは私たちの本当の家族よ、いつでも帰ってきてね」と言われたことは一生忘れません。'
      ],
      'imgURL': [
        'https://res.cloudinary.com/dc1aiqs4p/image/upload/c_thumb,w_500/v1688590421/Hostfamilyphotoedit_hvevxp.webp'
      ]
    },
    {
      'subtitle': '変わりたくて留学した、でも、予想と違う方に変わった。',
      'text': [
        '2005年、アメリカの田舎はまだまだLGBTフレンドリーというわけではなかったですし、今思えば自分のセクシャリティを隠している人も多かったはずなのですが、私は現地の高校で、カミングアウトをしている同い年のオープンリーGayがいることを知り「アメリカすげー!」と思ったのをよく覚えています。神社で「Gayが治りますように!」と神頼みしか出来なかった私にとって、彼との出会い(一方的に知っていただけ)は、私が自分らしさを認めるきっかけになったかもしれません。',
        'Gayである自分が嫌で留学した結果、Gayである自分を認められるようになり、世界が広いことを知り、もっと勉強したくなりました。自分の中で、予想もしていなかった心境の変化が起こり、帰国後、以前は興味の無かった大学受験を決め、無事合格し、一人暮らしの為に家を出る直前、家族にカミングアウトをしました。小さな枠の中で決めた目標でも、本気で達成しようと努力すると、その先で違う景色が見えるようになる、ということをここで初めて体験しました。'
      ]
    },
    {
      'subtitle': '5年後、ふたたびアメリカへ。',
      'text': [
        '2010年8月、20歳の時、高校時代に住んでいたミネソタ州に再度行ったことを誰かに話すと「またあんな田舎に行ったの?!」と言われます。笑',
        '今度は州立大学に1年間の交換留学をしました。高校の時と状況は変わって、日本人含め留学生がたくさんいたので、英語onlyの環境にするには工夫が必要でした。日本人同士でもなるべく英語で話す、他の国の留学生や現地の友達を作る、などです。「みんなで英語がうまくなろう!」という向上心さえ共有できれば、日本人の友達と仲良くするのは、悪いことではないと思います。それも一期一会ですし、なんと言っても、ここで仲良くなった友人たちとはその後10年以上経った今も結婚式に呼び合う仲になれたのですから。',
        'とにかく勉学も遊びもイベントも積極的に取り組みました。成績はGPA満点の4.0。日本語の授業にボランティアで教えに行ったり、日本フェスの企画や、ここでもバンドを組んで学校のイベントで演奏しました。',
        '限られた時間を充実させられるかどうかは、とにかく勇気を出した行動にかかっていると思います。'
      ],
      'imgURL': [
        'https://res.cloudinary.com/dc1aiqs4p/image/upload/c_thumb,w_750/v1688575987/Aboutsectionthree_redhpq.webp',
      ],
      'increaseImgSize': true
    },
    {
      'subtitle': '大学卒業後、英語を教える仕事につく。',
      'text': [
        '2011年10月、大学4年次、商社の海外営業職に内定が決まっていた私は、英語を使える理想の仕事がようやく決まったのと裏腹に、どこかモヤモヤしており、就職活動を再開しました。それまで考えたことも無かった「英語を教える仕事」を探し、最終的に最初の商社も含め3社で悩んだ末、アドバイスをたくさん聞きつつ、結局直感に従い大手の英会話スクールの講師になることを決めました。',
        '教えることはとても楽しく、向いていると思いました。現在のティーチングスタイルの基盤ができたのも、この会社でみっちり研修を受けたおかげです。後に、どうしてもしたかった起業の為に退職します。起業の話は、また後程。'
      ]
    },
    {
      'subtitle': '起業の傍ら、フリーランスの英語講師と専門学校講師と翻訳の仕事を始める。',
      'text': [
        '2013年、英会話スクールの講師を辞めた私に、知人から「私の娘がそうちゃんから英語を習いたいと言っている」と連絡をもらいます。それがフリーランスの英語講師になったきっかけです。ありがたいことに、生徒がまた他の生徒を紹介し、順調に生徒数が増えていきました。',
        '一人の生徒が専門学校の講師をしていて「勤務先の学校が英会話の先生を探している!」とお話をいただいたことが、専門学校でも教鞭をとることになったきっかけです。他の専門学校ともご縁があり、3校で勤務しました。幸運にも、この専門学校で英語界隈のベストセラー著者の先生方と共に働くことができ、日本で最先端で最高峰のうちの一つの英語教授法を学ぶことができ、講師として大きくレベルアップできました。',
        'また他の方から「翻訳できる人を探している！」とお話をいただき、翻訳の仕事も始めました。',
        '2021年の3度目の留学まで、起業・専門学校講師・フリーランス講師・翻訳を受け持っておりました。この頃には、英語講師を始めてから10年目を迎えようとしていました。'
      ]
    },
    {
      'subtitle': '30代、三度目の留学を決意、IELTS一発合格。',
      'text': [
        '前回の留学から11年の時間が経った2021年9月、32歳の時、今度はベルギーの首都ブリュッセルにある大学院の言語学部に留学し、第二言語習得を専攻しました。',
        '大学院受験を考え始めたのはその2年前の2019年。受験資格はIELTS OA6.5、大学の成績GPA平均3.2以上、言語学に関係する分野の学士を持つこと、もしくは関係する職務経験があることでした。IELTS以外は幸いにも条件を満たしていたので、約2年かけて仕事をしながらゆっくりIELTS受験の準備をしました。',
        'IELTSとは、ヨーロッパ、イギリス、オーストラリアの大学、大学院に進学する際によく用いられる英語運用能力を証明する試験です(アメリカの大学ではIELTSかTOEFLが使われることが多いです)。日本ではTOEICが主流ですが、TOEICでいける海外の学校はほとんど無いでしょう。',
        '英語の資格試験は、目標点を取れるまで何度も受けるのが主流ですが、私は絶対に一度の受験で終わらせたかったのです。なぜか。受験料が2万5千円もするから!これから社会人留学をする前にできるだけ出費を抑えたかったので、独学で準備をしました。',
        '1年目は受験勉強の準備、ゆっくり確実にIELTSの語彙をすべて覚えました。2年目は、普段授業で生徒の為に行っている現状分析と一年間の詳細な学習プラン立てをし、無事、受験1年前に受けた模擬試験結果OA5.5から、OA7.0まで伸ばし、一度の本番受験で大学院受験資格を満たすことができました。',
        '試験準備で大切なのは、やはり綿密な学習計画でした。'
      ]
    },
    {
      'subtitle': '何歳でも、留学できる。',
      'text': [
        '30を超えてからの海外生活は、実を言うと不安だらけでした。10代の時は出来ないことが多くても可愛がってくれますし、教えてもらえます。大人の留学は、例え文化が違ってわからないことだらけでも、助けてもらえないのではないか、友達ができないのではないか、と心配していました。',
        '結果的には、多くの人に支えられ、友人ができた1年間になりました。この経験を通して、何歳になってからでも楽しい留学はできる!という結論にいたりました。'
      ],
      'imgURL': [
        'https://res.cloudinary.com/dc1aiqs4p/image/upload/c_thumb,w_500/v1688605926/Sodinnertablephotoedit_1_tm2unj.webp'
      ]
    },
    {
      'subtitle': 'ベルギー留学は、結婚する為。',
      'text': [
        'そうそう、ベルギーに行った一番の目的は「同性結婚が認められている国でパートナーを見つける」ことだったので、日本の家族や友人とは今生の別れのようでしたが、そんな簡単に相手が見つかるわけもなく、あっさりビザ切れで帰国しました。',
        'それでも、夢の実現の為に必死に動いたこの１年は、他には代えがたい、とてもハリのある素敵な時間でした。',
        '大切なのは、どんな生き方をするか、それに尽きると思います。だからSOは、これからも止まりません。'
      ],
      'imgURL': [
        'https://res.cloudinary.com/dc1aiqs4p/image/upload/c_thumb,w_500/v1688596438/Socastlephotoedit_tvozdp.webp'
      ]
    },
    {
      'subtitle': '18年ぶりの家族旅行。',
      'text': [
        'ここで一つAfter Storyを。2023年3月、高校生の時のホストファミリーとコスタリカに行きました。なんと18年ぶりの家族旅行です。',
        'その時Motherが私に"You have always been a part of our family(あなたはずっと、私たちの大事な家族よ)"と言ってくれ、留学後もこうして英語を勉強を続け、連絡を取り続けていて良かった、と心から思いました。'
      ],
      'imgURL': [
        'https://res.cloudinary.com/dc1aiqs4p/image/upload/c_thumb,w_500/v1688593992/Familytripphotoedit_y0thsh.webp'
      ]
    },
    {
      'subtitle': '英語は世界への「チケット」。',
      'text': [
        '高校の留学で人生が変わって、そのおかげでGayである自分を認めることができて、フリーランスとして周りに左右されず自分らしい生き方ができて、本当に叶えたい人生の目標を追い続けることができています。',
        'そのきっかけは「英語」。',
        'やっぱり英語は、世界と、明るい未来への「チケット」でした。'
      ]
    },
    {
      'subtitle': '明日がもっと、楽しみになる。',
      'text': [
        '一人の人間のたかが30年少しの人生ですが、英語が連れて行ってくれた先の世界とその後の人生をご紹介したのは、これを読んだ方が英語を勉強をしている時、次の日が少し楽しみになってくれたらいいなと、思ったからです。',
        '私は毎日、英語を一緒に頑張ってくれている生徒の方々から、エネルギーと勇気をもらっていますから。',
        '英語と少しの勇気で、一緒に明日へ踏み出してみませんか？'
      ],
    },
  ]

  return(
    <div id="section5" className="bg-white">
      <AboutHero />
      <div className="px-6 sm:px-10 py-10 md:px-0 md:mx-20 lg:mx-40 xl:mx-60">
        <h2 className="text-yellow-500">Who's SO? <br/>SOの生い立ちと3度の留学経験</h2>
        {paragraphs && paragraphs.map((paragraph, index) => (
          <SectionTextbox 
            subtitle={paragraph.subtitle}
            key={index}
            imgURL={paragraph.imgURL}
            text={paragraph.text}
            increaseImgSize={paragraph.increaseImgSize && paragraph.increaseImgSize}
            currentIdx={index}
          />
        ))}
      </div>
    </div>
  )
}